import './section6.scss'

import { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'
import { DownloadIcon } from 'src/assets'
import { lowerLanguage } from 'src/i18n'
import { useGetDocument, usePutDossier } from 'src/networking/terminals'
import { atomDossier, pathAtom, selectorCarousel } from 'src/storage'
import {
  Carousel,
  Dossier,
  DynamicCardCTAStyle,
  DynamicCardProps,
  DynamicCardType,
  Message,
} from 'src/types'

import { ProductsCodeMap } from '../../../products_mapping.utils'
import { mapDossier } from 'src/utils'

export type ImageProps = {
  title: string
  description: string
  image: string
  link: Message
  carouselCode: string
}
export const useSection6 = () => {
  const { t } = useTranslation()
  const carousels = useRecoilValue(selectorCarousel)
  const [carouselItemList, setCarouselItemList] = useState<DynamicCardProps[]>([])
  const { crossGate: retrieveDocument } = useGetDocument()

  const createProduct = (carousel: Carousel): DynamicCardProps => {
    const link = carousel.link[lowerLanguage]
    const isRedirect = carousel.action?.toUpperCase().trim() === 'REDIRECT'

    let action = () => {}

    if (isRedirect && link) {
      action = () => {
        window.open(link.replaceAll('"', '').toString(), '_blank')
      }
    }

    if (!isRedirect) {
      action = () => {
        if (carousel.action.includes('-')) {
          switchDossier(carousel.action.split('-')[0])
          return
        }
        switchDossier(carousel.action)
      }
    }

    return {
      carouselCode: carousel.carouselCode,
      type: DynamicCardType.tile,
      title: carousel.title[lowerLanguage],
      description: carousel.description[lowerLanguage],
      image: carousel.imagePath,
      ctaLabel: carousel.actionTitle,
      ctaIcon: DownloadIcon,
      ctaStyle: DynamicCardCTAStyle.unfill,
      tagLabel: t('landing.section6.in_agenzia'),
      action,
      enableTMModal: false,
    }
  }

  useEffect(() => {
    const carouselsItems = carousels?.filter(
      (carousel) => !carousel.carouselCode.toUpperCase().includes('CAR_PRD_')
    )

    setCarouselItemList(carouselsItems?.map(createProduct) || [])
  }, [carousels])

  const [isMobile, setIsMobile] = useState(window.innerWidth < 810)

  const setPath = useSetRecoilState(pathAtom)

  useEffect(() => {
    setPath(location.pathname)
  }, [location.pathname, setPath])

  useEffect(() => {
    window.addEventListener(
      'resize',
      () => {
        const ismobile = window.innerWidth < 810
        if (ismobile !== isMobile) setIsMobile(ismobile)
      },
      false
    )
  }, [isMobile])
  const reduceRecipes = (
    acc: DynamicCardProps[][],
    cur: DynamicCardProps,
    index: number,
    array: DynamicCardProps[]
  ) => {
    const groupIndex = Math.floor(index / 3)
    if (!acc[groupIndex]) acc[groupIndex] = []
    acc[groupIndex].push(cur)

    if (index === array.length - 1 && acc[groupIndex].length < 3) {
      let i = 0
      while (acc[groupIndex].length < 3) {
        acc[groupIndex].push(array[i])
        i++
      }
    }

    return acc
  }

  const groupedItems = useMemo(() => {
    if (isMobile) {
      return carouselItemList.map((item) => [item])
    }

    const filteredItems = carouselItemList.filter(
      (carousel) => !carousel.carouselCode.includes('CAR_MKT')
    )

    return filteredItems.reduce(reduceRecipes, [])
  }, [carouselItemList, isMobile])

  const openDocument = (link: string) => {
    if (!link) return

    window.open(link.replaceAll('"', '').toString(), '_blank')
    /*if (base64) {
      const byteCharacters = atob(base64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      window.open(url, "_blank");
    }*/
  }

  const getDocument = (docCode: string) => {
    if (docCode === 'CAR_RC_5') {
      switchDossier(ProductsCodeMap.US01)
      return
    }
    retrieveDocument(
      {
        uriParams: {
          docCode: docCode,
        },
      },
      {
        onSuccess: (response) => {
          openDocument(response?.carousel?.link[lowerLanguage])
        },
      }
    )
  }

  const [dossier, setDossier] = useRecoilState(atomDossier)
  const { crossGate: putDossier } = usePutDossier()
  function switchDossier(productCode: string): void {
    putDossier(
      {
        headers: {
          xDossierId: dossier.dossierId,
        },
        body: {
          productCode: productCode,
        },
      },
      {
        onSuccess: (newDossier) => {
          const dossier: Dossier = mapDossier(newDossier)
          setDossier(dossier)
        },
      }
    )
  }

  return {
    t,
    groupedItems,
    isMobile,
    getDocument,
  }
}
